import type {Worker} from "@mytour/shared";
import {Button} from "reactstrap";
import {useRegenerateWorkerPassword} from "../../../../query/teamWorkerQueries.js";

interface RegenerateWorkerPasswordActionProps {
  worker: Worker;
}

export function RegenerateWorkerPasswordAction({worker}: RegenerateWorkerPasswordActionProps) {
  const {regenerateWorkerPassword, isRegeneratingWorkerPassword} = useRegenerateWorkerPassword();

  const handleRegenerate = async () => {
    await regenerateWorkerPassword(worker.id);
  };

  return (
    <Button
      size="sm"
      color="primary"
      outline
      onClick={handleRegenerate}
      disabled={isRegeneratingWorkerPassword}
    >
      Régénérer mot de passe
    </Button>
  );
}
